import { type FormEvent } from "react";
import { categories } from "@/mocks/gossipData";

interface GossipToolbarProps {
  activeCategory: string;
  keyword: string;
  sort: string;
  total: number;
  onCategoryChange: (slug: string) => void;
  onKeywordChange: (value: string) => void;
  onSearch: () => void;
  onSortChange: (value: string) => void;
}

const ALL_TAB = { slug: "all", name: "全部合集" };

export default function GossipToolbar({
  activeCategory,
  keyword,
  sort,
  total,
  onCategoryChange,
  onKeywordChange,
  onSearch,
  onSortChange,
}: GossipToolbarProps) {
  const tabs = [ALL_TAB, ...categories.map((item) => ({ slug: item.slug, name: item.name }))];

  const submit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSearch();
  };

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-wrap items-center gap-x-1 gap-y-1 rounded-full border border-background-200 bg-background-100 p-1">
        {tabs.map((tab) => (
          <button
            key={tab.slug}
            type="button"
            onClick={() => onCategoryChange(tab.slug)}
            className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-label transition-colors cursor-pointer ${
              activeCategory === tab.slug
                ? "bg-background-50 text-primary-700"
                : "text-foreground-600 hover:text-foreground-950"
            }`}
          >
            {tab.name}
          </button>
        ))}
      </div>

      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <form
          onSubmit={submit}
          role="search"
          className="flex w-full items-center gap-2 rounded-full border border-background-300 bg-background-50 p-1.5 sm:max-w-md"
        >
          <span className="flex h-9 w-9 shrink-0 items-center justify-center text-foreground-400">
            <i className="ri-search-line text-lg" aria-hidden="true" />
          </span>
          <label htmlFor="gossip-search" className="sr-only">
            搜索合集
          </label>
          <input
            id="gossip-search"
            name="q"
            type="search"
            value={keyword}
            onChange={(event) => onKeywordChange(event.target.value)}
            placeholder="搜索合集标题或标签"
            className="h-9 w-full flex-1 bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
          />
          <button
            type="submit"
            className="h-9 whitespace-nowrap rounded-full bg-primary-500 px-5 text-sm font-label text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            搜索
          </button>
        </form>

        <div className="flex items-center justify-between gap-3">
          <span className="whitespace-nowrap text-sm text-foreground-500">
            共 {total} 篇合集
          </span>
          <div className="flex items-center gap-2">
            <label htmlFor="gossip-sort" className="sr-only">
              排序方式
            </label>
            <select
              id="gossip-sort"
              name="sort"
              value={sort}
              onChange={(event) => onSortChange(event.target.value)}
              className="h-9 cursor-pointer rounded-full border border-background-300 bg-background-50 px-3 text-sm font-label text-foreground-700 outline-none focus:border-primary-400"
            >
              <option value="latest">最新更新</option>
              <option value="hot">阅读最多</option>
              <option value="title">标题排序</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
}